module.exports = __webpack_public_path__ + "img/action3.d74c980f.jpg";